import { render, staticRenderFns } from "./Dingdan.vue?vue&type=template&id=4661b846&"
import script from "./Dingdan.vue?vue&type=script&lang=js&"
export * from "./Dingdan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports